import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-current-location-icon',
  imports: [],
  templateUrl: './current-location-icon.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentLocationIcon {}
